/**
 * ¿La lista de tarjetas que tiene la página es sólo una parte de las que hay?
 *
 * La página pide `limit: 100`, que es el tope que acepta el schema
 * (`hikvisionAccessSchema.js`: `isInt({ min: 1, max: 100 })`), y el controller
 * ordena por `createdAt` desc y devuelve una sola rebanada. Con más de 100
 * tarjetas, las viejas nunca llegan al cliente, y el filtro por patio, la
 * búsqueda y el export operan sobre las 100 más nuevas sin decirlo: "Sin
 * patio" o un patio concreto muestran menos de lo que hay.
 *
 * `total` es confiable para esto: `getAccessCardList` lo calcula como el largo
 * de TODAS las tarjetas no borradas de la empresa antes de paginar, y la página
 * no le pasa filtros al backend, así que es el universo completo.
 *
 * Módulo puro por la misma razón que `cardYards.ts`: la página arrastra
 * firebase y no se puede testear en un worktree sin `.env`.
 */
export function isCardListTruncated(
  total: number | null | undefined,
  shown: number,
): boolean {
  // Sin pagination (todavía no llegó la primera respuesta, o falló) no hay con
  // qué afirmar que falta algo; avisar ahí sería inventar.
  if (typeof total !== "number") return false;
  // `>` y no `!==`: `createCard` antepone la tarjeta nueva a la lista sin tocar
  // `pagination`, así que por un instante `shown` puede superar a `total`, y
  // eso no es truncamiento.
  return total > shown;
}
